<template functional>
  <footer id="mainFooter">
  </footer>
</template>

<script>
export default{
  name: 'mainFooter'
}
</script>
